import type { FinancialMetricMode } from '../model/types'

import { FINANCIAL_METRIC_MODE_OPTIONS } from './getMetricModeTranslationKey'
import { normalizeFinancialMetricMode } from './normalizeFinancialMetricMode'

export const parseFinancialMetricModes = (value?: string | null): FinancialMetricMode[] => {
  const parsedModes = new Set<FinancialMetricMode>()

  value?.split(',').forEach((item) => {
    const normalizedMode = normalizeFinancialMetricMode(item)

    if (normalizedMode) {
      parsedModes.add(normalizedMode)
    }
  })

  if (parsedModes.size === 0) {
    return [...FINANCIAL_METRIC_MODE_OPTIONS]
  }

  return FINANCIAL_METRIC_MODE_OPTIONS.filter((mode) => parsedModes.has(mode))
}
